module.exports = __webpack_public_path__ + "static/img/login-banner.50794abe.png";